<template>
  <div class="vg-view-field-list">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VgViewFieldList"
}
</script>

<style scoped>
.vg-view-field-list {
  font-size: 16px;
  /*font-weight: 550;*/
}

.vg-view-field-list > .vg-view-field:after {
  content: "";
  /*display: block;*/
  position: absolute;
  border-bottom: solid 1px #E7E5E7;
  left: 10px;
  right: 10px;
  bottom: 0;
}

.vg-view-field-list.no-hr {
  padding: 5px 0;
}

.vg-view-field-list.no-hr > .vg-view-field {
  padding: 5px 10px;
}

.vg-view-field-list.no-hr > .vg-view-field:after,
.vg-view-field-list > .vg-view-field:last-child:after {
  display: none;
}

.vg-view-field-list.space-between > .vg-view-field {
  justify-content: space-between;
}
</style>